module.exports = __webpack_public_path__ + "static/innovation_card_img1@2x-f149e23d93822d594ca62d4786b6077e.jpg";